import clsx from 'clsx';
import React from 'react';
import capitalize from '@insurancemenu/imenu-components-lib/dist/helpers/capitalize';
import { AssigneeType as Type } from 'types/groupService';
import { createStyles } from './styles';

export interface AgentTagPropsType {
  type: Type;
}

const AssigneeType = (params: AgentTagPropsType): JSX.Element => {
  const { type } = params;
  const classes = createStyles();

  return (
    <div className={clsx(classes.tag, classes[`tagType_${Type[type]}`])}>
      {Type[type]
        .toLowerCase()
        .split('_')
        .map((agentName) => capitalize(agentName))
        .join(' ')}
    </div>
  );
};

export default AssigneeType;
